import React, { useRef, useState } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import { DragType } from './dnd'
import Checkbox from '../Checkbox'

export default ({ checked, expanded, project, items, onCheck, onExpand, onMoveItem, onAddToProject }) => {
    const ref = useRef(null)
    const [willDrop, setWillDrop] = useState(false)
    const [isFocused, setIsFocused] = useState(false)

    const [{ isDragging }, drag] = useDrag({
        item: { type: DragType.Project, id: project.id, ref },
        collect: monitor => ({ isDragging: !!monitor.isDragging() })
    })

    const [{ isOver, canDrop }, drop] = useDrop({
        accept: [DragType.Parcel, DragType.Project],
        hover: (item, monitor) => {
            if (project.id === item.id) {
                return
            }
            const sourceRect = item.ref.current.getBoundingClientRect()
            const targetRect = ref.current.getBoundingClientRect()
            const { y } = monitor.getClientOffset()
            const direction = sourceRect.top > targetRect.top ? 'up' : 'down'
            const height = targetRect.bottom - targetRect.top
            const half = targetRect.top + height / 2
            const action = item.type === DragType.Project || Math.abs(y - half) > height / 4 ? 'move' : 'drop'

            if (action === 'move') {
                setWillDrop(false)

                if (direction === 'up' && y < half) {
                    onMoveItem(item.id, project.id, 'before')
                } else if (direction === 'down' && y > half) {
                    onMoveItem(item.id, project.id, 'after')
                }
            } else {
                setWillDrop(true)
            }
        },
        drop: (item, monitor) => {
            if (willDrop) {
                onAddToProject(item.id, project.id)
                setWillDrop(false)
            }
        },
        collect: monitor => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        })
    })

    drag(drop(ref))

    return (
        <tr
            ref={ref}
            className={`${isDragging ? 'is-dragging' : ''} ${willDrop && isOver && canDrop ? 'will-drop' : ''}`}
        >
            <td>
                <Checkbox
                    checked={checked}
                    additionalClasses=""
                    onClick={onCheck}
                    aria-label="Checkbox to select this parcel"
                />
            </td>
            <td colSpan={2}>
                <div
                    onClick={() => onExpand(project.id)}
                    onKeyDown={e => (e.key === 'Enter' ? onExpand(project.id) : null)}
                    role="button"
                    tabIndex="0"
                >
                    <div className={`triangle ${expanded ? 'expanded' : 'collapsed'}`} /> {project.label}{' '}
                    {`(${items.length} parcels)`}
                </div>
            </td>
        </tr>
    )
}
